import {textFilterParamsValues} from "../reactTableController";
import AwInputCheckBox from "../../react/AwInputCheckBox";
import { booleanFilterParams, getBooleanValueGetter } from "../../utils/booleanColUtils";

export const defaultSortModel = [
    {
        colId: 'f13DateTime',
        sort: 'desc',
        sortIndex: 0
    }
];
export const reactIntradaysCols = function ( translate, filterFormatter, scope) {
    return [{
        field: "f13DateTime",
        headerName: translate.instant('DATE_TIME'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsDateTimeNoLocal')( params.data.f13DateTime) : "";
        }
    }, {
        field: "statementNoOrig",
        headerName: translate.instant('STATEMENT_NUMB_ORIGINAL'),
        sortable: true,
        filter: 'agNumberColumnFilter'
    }, {
        field: "transactionRefNo",
        headerName: translate.instant('TRANS_REF'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    }, {
        field: "debitSum",
        headerName: translate.instant('DEBIT_SUM'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.debitSum, scope.fractionDigits) : "";
        },
        type: 'numericColumn'
    }, {
        field: "debitCount",
        headerName: translate.instant('DEBIT_COUNT'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.debitCount) : "";
        },
        type: 'numericColumn'
    }, {
        field: "creditSum",
        headerName: translate.instant('CREDIT_SUM'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.creditSum, scope.fractionDigits) : "";
        },
        type: 'numericColumn'
    },  {
        field: "creditCount",
        headerName: translate.instant('CREDIT_COUNT'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.creditCount) : "";
        },
        type: 'numericColumn'
    }, {
        field: "f86Bank",
        headerName: translate.instant('INF_TO_ACCOWN'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "unread",
        headerName: translate.instant('UNREAD'),
        filter: "agSetColumnFilter",
        filterParams: { values: ['UNREAD', 'READ'],
                        valueFormatter: (params) => {
                            return translate.instant(params.value)
                        }},
        cellRenderer: AwInputCheckBox,
        cellRendererParams: {property: 'unread'}
    },{
        field: "camt052",
        headerName: translate.instant('CAMT052'),
        sortable: true,
        filter: 'agSetColumnFilter',
        filterParams: booleanFilterParams('camt052', translate),
        valueGetter: getBooleanValueGetter('camt052', translate, data => data?.account?.camt052),
        initialHide: true
    }];
}
